import { render } from "./viewSchoolCard.vue?vue&type=template&id=58aeaea5&scoped=true"
import script from "./viewSchoolCard.vue?vue&type=script&lang=js"
export * from "./viewSchoolCard.vue?vue&type=script&lang=js"

import "./viewSchoolCard.vue?vue&type=style&index=0&id=58aeaea5&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58aeaea5"]])

export default __exports__